import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";
export var Address = function Address(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      companyName = _ref.companyName,
      streetAddress1 = _ref.streetAddress1,
      streetAddress2 = _ref.streetAddress2,
      city = _ref.city,
      postalCode = _ref.postalCode,
      countryArea = _ref.countryArea,
      country = _ref.country,
      phone = _ref.phone;
  var intl = useIntl();
  return React.createElement(S.Wrapper, null, React.createElement(S.Name, null, "".concat(firstName, " ").concat(lastName)), companyName && React.createElement("span", null, companyName, " ", React.createElement("br", null)), React.createElement("span", null, streetAddress1), React.createElement("br", null), streetAddress2 && React.createElement("span", null, streetAddress2, " ", React.createElement("br", null)), React.createElement("span", null, postalCode && "".concat(postalCode, ","), " ", city), React.createElement("br", null), React.createElement("span", null, countryArea && React.createElement(React.Fragment, null, countryArea, ", "), country === null || country === void 0 ? void 0 : country.country), React.createElement("br", null), phone && React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Phone number:",
    "id": "@next.components.atoms.Address.Address.2705264409"
  }, "id", "@next.components.atoms.Address.Address.2705264409")), phone, " ", React.createElement("br", null)));
};